import React from 'react'
import { Form, Input } from 'antd';
import { rules } from '../cuit-mail-form/cuit-mail-form.rules';

function addStr(str, index, stringToAdd) {
    return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
}


const Cuit = ({ form: { getFieldValue, setFieldsValue } }) => {


    const handleChangeCuit = e => {
        const cuit = getFieldValue('cuit');
        const { value: input } = e.target;

        if (cuit.charAt(input.length - 1) === "-") {
            const without_dashed = input.slice(0, -1)
            setFieldsValue({ cuit: without_dashed })
        }

        else {
            if (((cuit.length === 3) || (cuit.length === 12))) {

                const dash_occurences = cuit.split("-").length - 1;

                if (dash_occurences >= 0 & dash_occurences <= 1) {
                    const cuit_dashed = (cuit.length === 3) ?
                        addStr(input, 2, '-') : addStr(input, 11, '-')

                    setFieldsValue({ cuit: cuit_dashed })
                }
            }
            else setFieldsValue({ cuit: input })
        }
    }


    return (
        <Form.Item label="CUIT/CUIL">
            <Form.Item
                name="cuit"
                rules={[...rules.cuit]}
                validateTrigger={["onChange", "onBlur"]}
            >
                <Input
                    maxLength={13}
                    size="large"
                    onChange={handleChangeCuit} />
            </Form.Item>
        </Form.Item >
    );
}

export default Cuit;